import React from 'react';
import { useData } from 'vike-react/useData';
import { FlexiblePageInput } from '@/pages/types';
import { ReadonlyComponentRenderer } from '@mutiny-pkg/bin-ui/src/flexiblePages/components/ReadonlyComponentRenderer';
import { ThemeProvider } from '@mutiny-pkg/bin-ui/src/rigidMicrosites/theme/ThemeProvider';
import { ThemeProperties } from '@mutiny-pkg/champaign-schemas/src/schemas/themeProperties/types';
import { FlexiblePagePassword } from '@mutiny-pkg/bin-ui/src/flexiblePages/components/FlexiblePagePassword';
import { RenderStage } from '@mutiny-pkg/champaign-schemas/src/schemas/micrositePages/render';
import './componentClasses.css';

type FlexiblePageRendererProps = {
  pageId: string;
};

export function FlexiblePageRenderer({ pageId }: FlexiblePageRendererProps) {
  const { componentTree, overrideVariables, password, passwordEnabled, renderStage, staticSiteDomain, bodySnippets } =
    useData<FlexiblePageInput>();
  const theme = componentTree.data as unknown as ThemeProperties;

  return (
    <ThemeProvider theme={theme}>
      {bodySnippets && <div style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: bodySnippets }} />}
      <ReadonlyComponentRenderer
        componentTree={componentTree}
        overrideVariables={overrideVariables}
        staticAssetsBaseURL={staticSiteDomain}
        renderStage={renderStage}
      >
        {passwordEnabled && password && (
          <FlexiblePagePassword password={password} pageId={pageId} inPreview={renderStage === RenderStage.Preview} />
        )}
      </ReadonlyComponentRenderer>
    </ThemeProvider>
  );
}
